type ClassValue = string | number | false | null | undefined | Record<string, boolean>

/**
 * Tiny class-names helper. Accepts strings, falsy values to skip, or
 * `{ "active": isActive }` objects.
 */
export function cn(...values: ClassValue[]): string {
  const out: string[] = []
  for (const v of values) {
    if (!v) continue
    if (typeof v === 'string' || typeof v === 'number') {
      out.push(String(v))
      continue
    }
    for (const [key, on] of Object.entries(v)) {
      if (on) out.push(key)
    }
  }
  return out.join(' ')
}
